export default __webpack_public_path__ + "static/start-working-together-mobile-562767a0ddd11dc2787ee41b61b5836d.svg";